// extracted by mini-css-extract-plugin
export default {"page":"OfficesListForPms_page__Cqups","card":"OfficesListForPms_card__5mE3h","icon":"OfficesListForPms_icon__Umj5i"};